"use strict";
// import PropTypes, { InferProps } from "prop-types";
// import React from "react";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// function Report({
//     width,
//     height,
//     className,
// }: InferProps<typeof Report.propTypes>) {
//     return (
//         <svg
//             className={`icon ${className}`}
//             height={`${height}`}
//             width={`${width}`}
//             viewBox="0 0 106 106"
//         >
//             <g filter="url(#filter0_d_237_53265)">
//                 <path
//                     fill="#009CFF"
//                     d="M20.702 6.858C31.468 4.286 42.234 3 53 3c10.766 0 21.532 1.286 32.298 3.858a16 16 0 0111.844 11.844C99.714 29.468 101 40.234 101 51c0 10.766-1.286 21.532-3.858 32.298a16 16 0 01-11.844 11.844C74.532 97.714 63.766 99 53 99c-10.766 0-21.532-1.286-32.298-3.858A16 16 0 018.858 83.298C6.286 72.532 5 61.766 5 51c0-10.766 1.286-21.532 3.858-32.298A16 16 0 0120.702 6.858z"
//                 ></path>
//             </g>
//             <path
//                 fill="#009CFF"
//                 d="M20.702 6.858C31.468 4.286 42.234 3 53 3c10.766 0 21.532 1.286 32.298 3.858a16 16 0 0111.844 11.844C99.714 29.468 101 40.234 101 51c0 10.766-1.286 21.532-3.858 32.298a16 16 0 01-11.844 11.844C74.532 97.714 63.766 99 53 99c-10.766 0-21.532-1.286-32.298-3.858A16 16 0 018.858 83.298C6.286 72.532 5 61.766 5 51c0-10.766 1.286-21.532 3.858-32.298A16 16 0 0120.702 6.858z"
//             ></path>
//             <path
//                 fill="#fff"
//                 d="M48.396 24H67.44a3.795 3.795 0 013.838 3.752v43.026a3.782 3.782 0 01-3.823 3.752H38.823A3.782 3.782 0 0135 70.792V38.965h9.615a3.781 3.781 0 003.838-3.738V24h-.057zM35.014 37.096h9.601a1.898 1.898 0 001.898-1.883V24L35.014 37.096zm17.205 0v1.87H65.6v-1.87H52.22zm0-5.62v1.868H65.6V31.49H52.22v-.014zM40.806 42.703v1.868H65.6v-1.854H40.75l.056-.014zm0 5.62v1.87H65.6v-1.87H40.75h.056zm0 5.621v1.869H65.6v-1.869H40.75h.056zm0 5.62v1.87H65.6v-1.87H40.75h.056zm0 5.622v1.868H65.6v-1.883H40.75l.056.015z"
//             ></path>
//             <defs>
//                 <filter
//                     id="filter0_d_237_53265"
//                     width="106"
//                     height="106"
//                     x="0"
//                     y="0"
//                     colorInterpolationFilters="sRGB"
//                     filterUnits="userSpaceOnUse"
//                 >
//                     <feFlood
//                         floodOpacity="0"
//                         result="BackgroundImageFix"
//                     ></feFlood>
//                     <feColorMatrix
//                         in="SourceAlpha"
//                         result="hardAlpha"
//                         values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//                     ></feColorMatrix>
//                     <feOffset dy="2"></feOffset>
//                     <feGaussianBlur stdDeviation="2.5"></feGaussianBlur>
//                     <feColorMatrix values="0 0 0 0 0.674745 0 0 0 0 0.674745 0 0 0 0 0.674745 0 0 0 0.5 0"></feColorMatrix>
//                     <feBlend
//                         in2="BackgroundImageFix"
//                         result="effect1_dropShadow_237_53265"
//                     ></feBlend>
//                     <feBlend
//                         in="SourceGraphic"
//                         in2="effect1_dropShadow_237_53265"
//                         result="shape"
//                     ></feBlend>
//                 </filter>
//             </defs>
//         </svg>
//     );
// }
// Report.propTypes = {
//     width: PropTypes.number,
//     height: PropTypes.number,
//     className: PropTypes.string,
// };
// Report.defaultProps = {
//     width: 64,
//     height: 64,
// };
// export default Report;
var prop_types_1 = __importDefault(require("prop-types"));
var React = __importStar(require("react"));
function Report(_a) {
    var _b = _a.width, width = _b === void 0 ? 64 : _b, _c = _a.height, height = _c === void 0 ? 64 : _c, className = _a.className;
    return (React.createElement("svg", { className: className ? "icon ".concat(className) : "", height: "".concat(height), width: "".concat(width), viewBox: "0 0 106 106" },
        React.createElement("g", { filter: "url(#a)" },
            React.createElement("path", { d: "M20.702 6.858C31.468 4.286 42.234 3 53 3c10.766 0 21.532 1.286 32.298 3.858a16 16 0 0 1 11.844 11.844C99.714 29.468 101 40.234 101 51c0 10.766-1.286 21.532-3.858 32.298a16 16 0 0 1-11.844 11.844C74.532 97.714 63.766 99 53 99c-10.766 0-21.532-1.286-32.298-3.858A16 16 0 0 1 8.858 83.298C6.286 72.532 5 61.766 5 51c0-10.766 1.286-21.532 3.858-32.298A16 16 0 0 1 20.702 6.858Z", fill: "#009CFF" })),
        React.createElement("path", { d: "M20.702 6.858C31.468 4.286 42.234 3 53 3c10.766 0 21.532 1.286 32.298 3.858a16 16 0 0 1 11.844 11.844C99.714 29.468 101 40.234 101 51c0 10.766-1.286 21.532-3.858 32.298a16 16 0 0 1-11.844 11.844C74.532 97.714 63.766 99 53 99c-10.766 0-21.532-1.286-32.298-3.858A16 16 0 0 1 8.858 83.298C6.286 72.532 5 61.766 5 51c0-10.766 1.286-21.532 3.858-32.298A16 16 0 0 1 20.702 6.858Z", fill: "#009CFF" }),
        React.createElement("path", { d: "M48.396 24H67.44a3.795 3.795 0 0 1 3.838 3.752v43.026a3.782 3.782 0 0 1-3.823 3.752H38.823A3.782 3.782 0 0 1 35 70.792V38.965h9.615a3.781 3.781 0 0 0 3.838-3.738V24h-.057ZM35.014 37.096h9.601a1.898 1.898 0 0 0 1.898-1.883V24L35.014 37.096Zm17.205 0v1.87H65.6v-1.87H52.22Zm0-5.62v1.868H65.6V31.49H52.22v-.014ZM40.806 42.703v1.868H65.6v-1.854H40.75l.056-.014Zm0 5.62v1.87H65.6v-1.87H40.75h.056Zm0 5.621v1.869H65.6v-1.869H40.75h.056Zm0 5.62v1.87H65.6v-1.87H40.75h.056Zm0 5.622v1.868H65.6v-1.883H40.75l.056.015Z", fill: "#fff" }),
        React.createElement("defs", null,
            React.createElement("filter", { id: "a", x: 0, y: 0, width: 106, height: 106, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                React.createElement("feColorMatrix", { in: "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                React.createElement("feOffset", { dy: 2 }),
                React.createElement("feGaussianBlur", { stdDeviation: 2.5 }),
                React.createElement("feColorMatrix", { values: "0 0 0 0 0.674745 0 0 0 0 0.674745 0 0 0 0 0.674745 0 0 0 0.5 0" }),
                React.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_118_470" }),
                React.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_118_470", result: "shape" })))));
}
Report.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
};
exports.default = Report;
